// extracted by mini-css-extract-plugin
export var link = "_7-0";